import { render, staticRenderFns } from "./operationsStatistics.vue?vue&type=template&id=122ab099&scoped=true&"
import script from "./operationsStatistics.vue?vue&type=script&lang=js&"
export * from "./operationsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./operationsStatistics.vue?vue&type=style&index=0&id=122ab099&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ab099",
  null
  
)

export default component.exports